module.exports = __webpack_public_path__ + "static/media/duration_act.ff7815ca.svg";